export default __webpack_public_path__ + "static/media/clean-design.728069da.jpg";